var React = require('react');

function InfoFilled (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 0C10.746 0 0 10.746 0 24s10.746 24 24 24 24-10.746 24-24S37.254 0 24 0zm-1.5 12a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zm-2.25 7.5a1.5 1.5 0 000 3h1.5V30c0 2.484 2.016 4.5 4.5 4.5h1.5a1.5 1.5 0 000-3h-1.5a1.5 1.5 0 01-1.5-1.5v-7.5a3 3 0 00-3-3h-1.5z"}));
}

InfoFilled.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = InfoFilled;

InfoFilled.default = InfoFilled;
